import React from 'react'

export default () => {
  return (
    <svg
      style={{ borderRadius: '100px' }}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.37485 10.3119C2.95564 3.96225 9.41654 0.0916154 15.8045 1.66284C22.1942 3.23334 26.0896 9.65247 24.5089 16.0011C22.9278 22.3495 16.468 26.2218 10.0787 24.6503C3.69027 23.0798 -0.207203 16.6603 1.37485 10.3119Z"
        fill="#5579EF"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="24"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.37485 10.3119C2.95564 3.96225 9.41654 0.0916154 15.8045 1.66284C22.1942 3.23334 26.0896 9.65247 24.5089 16.0011C22.9278 22.3495 16.468 26.2218 10.0787 24.6503C3.69027 23.0798 -0.207203 16.6603 1.37485 10.3119Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect
          x="-0.348389"
          y="-1.26367"
          width="29.617"
          height="8.28095"
          fill="#E25A63"
        />
        <rect
          x="-0.348389"
          y="19.3542"
          width="29.617"
          height="8.28095"
          fill="#E25A63"
        />
        <rect
          x="-0.348389"
          y="6.52795"
          width="29.617"
          height="13.3155"
          fill="#F5C055"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 24.8289C19.6274 24.8289 25 19.4946 25 12.9144C25 6.33427 19.6274 1 13 1C6.37258 1 1 6.33427 1 12.9144C1 19.4946 6.37258 24.8289 13 24.8289Z"
        stroke="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9196 9.73395C10.7649 10.2811 10.1547 10.6895 9.42559 10.6895C8.69647 10.6895 8.08632 10.2811 7.93159 9.73395H7.85575C7.70102 10.2811 7.09087 10.6895 6.36175 10.6895C5.63263 10.6895 5.02248 10.2811 4.86775 9.73395H4.82983V14.0669C4.82983 15.747 7.89366 17.1089 7.89366 17.1089C7.89366 17.1089 10.9575 15.747 10.9575 14.0669V9.73395H10.9196Z"
        fill="#E25A63"
      />
      <path
        d="M10.9196 9.73395V9.23395C10.6959 9.23395 10.4993 9.38258 10.4385 9.59788L10.9196 9.73395ZM7.93159 9.73395L8.41272 9.59788C8.35183 9.38258 8.15533 9.23395 7.93159 9.23395V9.73395ZM7.85575 9.73395V9.23395C7.63201 9.23395 7.43551 9.38258 7.37462 9.59788L7.85575 9.73395ZM4.86775 9.73395L5.34888 9.59788C5.28799 9.38258 5.09149 9.23395 4.86775 9.23395V9.73395ZM4.82983 9.73395V9.23395C4.55369 9.23395 4.32983 9.45781 4.32983 9.73395H4.82983ZM7.89366 17.1089L7.69056 17.5658C7.81986 17.6233 7.96746 17.6233 8.09676 17.5658L7.89366 17.1089ZM10.9575 9.73395H11.4575C11.4575 9.45781 11.2336 9.23395 10.9575 9.23395V9.73395ZM9.42559 11.1895C10.315 11.1895 11.1694 10.6879 11.4007 9.87002L10.4385 9.59788C10.3603 9.87426 9.99438 10.1895 9.42559 10.1895V11.1895ZM7.45046 9.87002C7.68176 10.6879 8.53614 11.1895 9.42559 11.1895V10.1895C8.8568 10.1895 8.49089 9.87426 8.41272 9.59788L7.45046 9.87002ZM7.93159 9.23395H7.85575V10.2339H7.93159V9.23395ZM7.37462 9.59788C7.29645 9.87426 6.93054 10.1895 6.36175 10.1895V11.1895C7.2512 11.1895 8.10558 10.6879 8.33688 9.87002L7.37462 9.59788ZM6.36175 10.1895C5.79296 10.1895 5.42704 9.87426 5.34888 9.59788L4.38662 9.87002C4.61792 10.6879 5.4723 11.1895 6.36175 11.1895V10.1895ZM4.86775 9.23395H4.82983V10.2339H4.86775V9.23395ZM4.32983 9.73395V14.0669H5.32983V9.73395H4.32983ZM4.32983 14.0669C4.32983 14.6416 4.59085 15.1487 4.91607 15.5608C5.24315 15.9752 5.66675 16.3342 6.06995 16.624C6.47594 16.9158 6.87895 17.1499 7.17876 17.3106C7.32925 17.3912 7.45516 17.4541 7.5443 17.4972C7.5889 17.5188 7.62439 17.5355 7.64925 17.547C7.66169 17.5527 7.67147 17.5572 7.67842 17.5603C7.68189 17.5619 7.68466 17.5632 7.68669 17.5641C7.6877 17.5645 7.68854 17.5649 7.68918 17.5652C7.68951 17.5653 7.68978 17.5655 7.69002 17.5656C7.69013 17.5656 7.69027 17.5657 7.69033 17.5657C7.69045 17.5658 7.69056 17.5658 7.89366 17.1089C8.09676 16.652 8.09685 16.6521 8.09693 16.6521C8.09694 16.6521 8.09701 16.6521 8.09703 16.6521C8.09708 16.6522 8.09707 16.6522 8.09703 16.6521C8.09693 16.6521 8.09666 16.652 8.0962 16.6518C8.09529 16.6514 8.09366 16.6506 8.09133 16.6496C8.08668 16.6475 8.07926 16.6441 8.06926 16.6395C8.04924 16.6302 8.0189 16.616 7.97973 16.597C7.90132 16.5591 7.78787 16.5024 7.65112 16.4292C7.37647 16.282 7.01351 16.0706 6.65355 15.8119C6.29079 15.5512 5.94843 15.2547 5.70104 14.9412C5.45179 14.6254 5.32983 14.3323 5.32983 14.0669H4.32983ZM7.89366 17.1089C8.09676 17.5658 8.09688 17.5658 8.097 17.5657C8.09706 17.5657 8.0972 17.5656 8.09731 17.5656C8.09754 17.5655 8.09782 17.5653 8.09814 17.5652C8.09879 17.5649 8.09962 17.5645 8.10064 17.5641C8.10267 17.5632 8.10544 17.5619 8.10891 17.5603C8.11586 17.5572 8.12564 17.5527 8.13807 17.547C8.16294 17.5355 8.19842 17.5188 8.24303 17.4972C8.33217 17.4541 8.45808 17.3912 8.60857 17.3106C8.90838 17.1499 9.31138 16.9158 9.71738 16.624C10.1206 16.3342 10.5442 15.9752 10.8713 15.5608C11.1965 15.1487 11.4575 14.6416 11.4575 14.0669H10.4575C10.4575 14.3323 10.3355 14.6254 10.0863 14.9412C9.83889 15.2547 9.49653 15.5512 9.13378 15.8119C8.77382 16.0706 8.41086 16.282 8.13621 16.4292C7.99946 16.5024 7.88601 16.5591 7.8076 16.597C7.76842 16.616 7.73809 16.6302 7.71807 16.6395C7.70806 16.6441 7.70064 16.6475 7.696 16.6496C7.69367 16.6506 7.69204 16.6514 7.69113 16.6518C7.69067 16.652 7.6904 16.6521 7.6903 16.6521C7.69025 16.6522 7.69025 16.6522 7.69029 16.6521C7.69032 16.6521 7.69038 16.6521 7.6904 16.6521C7.69047 16.6521 7.69056 16.652 7.89366 17.1089ZM11.4575 14.0669V9.73395H10.4575V14.0669H11.4575ZM10.9575 9.23395H10.9196V10.2339H10.9575V9.23395Z"
        fill="#E25A63"
      />
    </svg>
  )
}
